<div class="celerity-local-container">
  <div>
    <fa-icon [icon]="faClipboard" class="celerity-local-icon display-3"></fa-icon>
    <p class="text-muted">
      <ng-content></ng-content>
    </p>
  </div>
</div>
